import RcInstanceDTO from '@robocorp/robocloud-internal-cds-sdk/lib/sdk/Types';
import { combineReducers } from 'redux';
import { UserAction, UserActionType } from '../../actions/userActions';

const current = (state = {} as RcInstanceDTO.User, action: UserAction) => {
  switch (action.type) {
    case UserActionType.GET_CURRENT_USER_OK: {
      return action.data;
    }
    case UserActionType.EDIT_CURRENT_USER_OK: {
      return { ...state, ...action.data };
    }
    case UserActionType.UPDATE_CURRENT_USER_DETAILS_OK: {
      return { ...state, details: action.data };
    }
    case UserActionType.REQUEST_SLACK_INVITE_OK: {
      state.details.slack_invite_requested = true;
      return state;
    }
    default:
      return state;
  }
};

type HistoryEvent = {
  timestamp: string;
  url: string;
};

const history = (state: HistoryEvent[] = [], action: UserAction) => {
  switch (action.type) {
    case UserActionType.ADD_HISTORY_EVENT:
      return state.concat({
        url: action.event,
        timestamp: new Date().toISOString(),
      });
    default:
      return state;
  }
};

export default combineReducers({ current, history });
